<template>
  <div class="user-center">
    <div class="top">
      <Top :topData="topData"/>
    </div>

    <!-- 图表 -->
    <div class="charts">
      <a-row :gutter="20">
        <a-col :span="24">
          <a-card :bordered="false">
            <!-- <h2 slot="title" style="font-weight:bold;font-size:16px;">产品到期时间分布图</h2> -->
            <div>
              <a-radio-group  v-model="chartparam.type" @change="typeChange">
                <a-radio-button value="cert">证书数量</a-radio-button>
                <a-radio-button value="report">报告数量</a-radio-button>
              </a-radio-group>
              <a-radio-group  @change="expireChange" v-model="chartparam.date" style="position:absolute;right:10px;">
                <a-radio-button value="week">本周</a-radio-button>
                <a-radio-button value="month">本月</a-radio-button>
                <a-radio-button value="year">本年</a-radio-button>
              </a-radio-group>
            </div>
            

            <div class="ve" v-if="showCharts" style="width:60%;float:left;">
              <ve-histogram ref="histogram" :legend-visible="false" :data="chartData1" :yAxis="yAxis" ></ve-histogram>
            </div>
            <div style="width:35%;float:right;border-left:1px dashed #ccc;min-height:400px;padding-left:10px;">
              <h2 slot="title" style="font-weight:bold;font-size:16px;height:32px;">客户<span v-if="chartparam.type=='cert'">证书</span><span v-if="chartparam.type=='report'">报告</span>量排名</h2>
              <a-row :gutter="20" v-for="(item,index) in rightData" :key="item.deptId" style="margin-top:7px;">
                <a-col class="gutter-row" :span="3">
                  <div class="gutter-box" style="font-size:28px;border-radius:50%;border:2px solid #333;width:45px;height:45px;text-align:center">{{index+1}}</div>
                </a-col>
                <a-col class="gutter-row" :span="16">
                  <div class="gutter-box" style="text-align:right;line-height:40px;">{{item.name}}</div>
                </a-col>
                <a-col class="gutter-row" :span="5">
                  <div class="gutter-box" style="line-height:40px;">{{item.certNum}}份</div>
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
        <!-- <a-col :span="8">
          <a-card :bordered="false">
            <h2 slot="title" style="font-weight:bold;font-size:16px;height:32px;">客户报告量排名</h2>
            <a-row :gutter="20" v-for="(item,index) in rightData" :key="item.deptId">
              <a-col class="gutter-row" :span="3">
                <div class="gutter-box" style="font-size:28px;">{{index+1}}</div>
              </a-col>
              <a-col class="gutter-row" :span="16">
                <div class="gutter-box" style="text-align:right;line-height:40px;">{{item.name}}</div>
              </a-col>
              <a-col class="gutter-row" :span="5">
                <div class="gutter-box" style="line-height:40px;">{{item.certNum}}份</div>
              </a-col>
            </a-row>
          </a-card>
        </a-col> -->
      </a-row>
    </div>

    <!-- 资讯 -->
    <!-- <div class="news">
      <div class="news-top">
        <a-button-group style="margin-bottom: 15px;">
          <a-button @click="toggleType('')" :type="messageParams.classify === '' ? 'primary' : ''">全部消息</a-button>
          <a-button @click="toggleType('WARNING')" :type="messageParams.classify === 'WARNING' ? 'primary' : ''">预警消息</a-button>
          <a-button @click="toggleType('INFORMATION')" :type="messageParams.classify === 'INFORMATION' ? 'primary' : ''">行业资讯</a-button>
        </a-button-group>

        <a-button type="link" class="look-more"><router-link to="/user/message">查看全部</router-link></a-button>
      </div>

      <a-divider style="margin: 0;"></a-divider>

      <a-list :dataSource="data">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-list-item-meta>
            <router-link slot="title" to="/"><span style="margin-right:15px;">{{index + 1}}</span><span>{{item.title}}</span></router-link>
          </a-list-item-meta>
          <div style="padding-right: 15px;">{{item.createdAt | moment('YYYY/MM/DD')}}</div>
        </a-list-item>
      </a-list>
    </div> -->
    <div class="right-menu">
        <ul>
            <li class="we-chat">
                <i class="iconfont icon">&#xe617;</i>
                <span class="max-text"><i class="iconfont">&#xe617;</i>微信咨询</span>
                <div class="we-img">
                    <div class="img"></div>
                </div>
            </li>
            <li>
                <i class="iconfont icon">&#xe613;</i>
                <span class="max-text"><i class="iconfont">&#xe613;</i>19906876274</span>
            </li>
            <li onclick="qimoChatClick()">
                <i class="iconfont icon">&#xe612;</i>
                <span class="max-text"><i class="iconfont">&#xe612;</i>在线咨询</span>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import Top from "@/components/users/agencyCenter/Top.vue";
import { 
  queryMessage,
  agencySummary,
  agencyClassifiedStatistic,
  agencyExpireMap
} from '@/api/user'
import { 
  mediationTop,
  mediationRight,
  mediationBottom,
} from '@/api/userCenter'
export default {
  components: { Top },
  data() {
    return {
        yAxis:[
          {
            type:'value',
            minInterval:1  //y轴整数
          }
        ],
      chartparam:{
        date:'week',
        type:'cert',
      },
      showCharts: false,
      chartData: {
        columns: ['name', 'presentationCount'],
        rows: []
      },
      chartData1: {
        columns: ['日期','数量'],
        rows: []
      },
      data: [],
      rightData: [],
      topData:{},
      messageParams: {
        classify: ''
      }
    };
  },

  mounted() {
    this.$nextTick( _ => {
      this.showCharts = true
      setTimeout(() => {
        if(this.$refs.histogram.echarts.resize) {
          // this.$refs.pie.echarts.resize()
          this.$refs.histogram.echarts.resize()
        }
      }, 100);
    })
    // this.queryMessage()
    this.getAgencySummary()
    // this.getagencyClassifiedStatistic()
    this.getagencyExpireMap(this.chartparam)
    this.getmediationRight(this.chartparam)
  },

  methods: {
    toggleType(state) {
      this.messageParams.classify = state
      this.queryMessage()
    },
    
    expireChange(e){
      this.chartparam.date = e.target.value;
      this.getagencyExpireMap(this.chartparam);
      this.getmediationRight(this.chartparam)
    },
    typeChange(e){
      this.chartparam.type = e.target.value;
      this.getagencyExpireMap(this.chartparam);
      this.getmediationRight(this.chartparam)
    },
    async getagencyExpireMap(params) {
      try {
        let data = await mediationBottom(params)
        let newDatas=[]
        // 将 keys值更改为符合的
        data.map(item => {
          let keyMap ={'date':'日期','num':'数量'}
          let objs = Object.keys(item).reduce((newData, key) => {
            let newKey = keyMap[key] || key
            newData[newKey] = item[key]
            return newData
          }, {})
          newDatas.push(objs)
        })
        this.chartData1.rows = newDatas
      } catch (error) {
        
      }
    },
    async getmediationRight(params) {
      try {
        let data = await mediationRight(params)
        
        this.rightData = data.slice(0,6);
      } catch (error) {
        
      }
    },

    async getagencyClassifiedStatistic() {
      try {
        let data = await agencyClassifiedStatistic()
          this.chartData.rows = data
      } catch (error) {
        
      }
    },

    async getAgencySummary() {
      try {
        let data = await mediationTop()
          this.topData = data || {};
      } catch (error) {
        
      }
    },

    // 查询消息列表
    async queryMessage() {
      try {
        let data = await queryMessage(this.messageParams)
        if(data && data.content) {
          this.data = data.content
        }
      } catch (error) {
        
      }
    }
  }
};
</script>

<style lang="less" scoped>
.user-center {
  min-height: 100%;
  padding-bottom: 15px;
  background-color: #fff;
  .company{
    height: 40px;
    font-size: 30px;
    .num{
      width: 40px;
      height: 40px;
      border: 1px solid #333;
      font-size: 30px;
      font-weight: bold;
      border-radius: 100%;
      display: inline-block;
      text-align: center;
      line-height: 36px;
      margin-right: 30px;
    }
    .name{
      font-size: 20px;
      display: inline-block;
      line-height: 40px
      // float: right;
    }
  }
  .top {
    padding: 10px 15px 0;
    margin-bottom: 15px;

    .top-username {
      padding: 10px 0;
      font-size: 16px;
      padding: 15px 0 5px;
      border-bottom: 1px solid #eee;
      margin-bottom: 12px;
      color: #000;
    }
  }

  .charts {
    // margin-bottom: 30px;
    padding: 0 15px;

    .ant-card {
      box-shadow: 0px 0px 8px 0px rgba(0,0,0,.1);
      border-radius: 4px;
    }
  }

  .news {
    padding: 30px 15px 0;
    background-color: #fff;
    border: 1px solid #eee;
    margin: 15px 15px 0;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,.1);
    border-radius: 4px;

    .news-top {
      display: flex;
      align-items: bottom;
      justify-content: space-between;
    }
  }

  .right-menu {
    width: 45px;
    border-radius: 4px;
    min-height: 350px;
    /* display: flex; */
      /* -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
    flex-direction: column; */
    position: fixed;
    z-index: 999;
    right: 0;
    bottom: 200px;
    li {
      width: 45px;
      height: 48px;
      line-height: 48px;
      background: rgba(53,63,88,0.66);
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      cursor: pointer;
      color: #fff;
      text-align: center;
      font-size: 16px;
      position: relative;
      .we-img {
        position: absolute;
        width: 120px;
        height: 120px;
        left: -230px;
        top: 0;
        background-color: #fff;
        border-radius: 10px;
        display: none;
        .img {
          position: absolute;
          width: 90%;
          height: 90%;
          background: url('../../../assets/images/small-public.png') center no-repeat;
          background-size: 100% 100%;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .icon {
        position: absolute;
        z-index: 2;
        font-size: 24px;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(53,63,88,0.66);
        left: 0;
        top: 0;
        transition: left 1.2s;
      }
      .max-text {
        display: block;
        position: absolute;
        width: 160px;
        height: 48px;
        line-height: 48px;
        z-index: 3;
        left: 60px;
        top: -1px;
        background-image: linear-gradient(to right, rgb(90,211,151), rgba(0,175,131,1));
        color: #fff;
        border-radius: 5px 0 0 5px;
        font-size: 18px;
        transition: left 1s;
        padding: 0 10px;
        box-sizing: border-box;
        i{
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    li:last-child {
      border: none;
    }
    li:hover .max-text{
      left: -115px;
    }
    li:hover .icon {
      left: -20px;
    }
    .we-chat:hover .we-img{
      display: block;
    }
  }
}
</style>
